import { render } from "./TableSettingsModal.vue?vue&type=template&id=37aac652&scoped=true"
import script from "./TableSettingsModal.vue?vue&type=script&lang=js"
export * from "./TableSettingsModal.vue?vue&type=script&lang=js"

import "./TableSettingsModal.vue?vue&type=style&index=0&id=37aac652&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37aac652"]])

export default __exports__